module.exports = __webpack_public_path__ + "img/hcpbpjs.cc24682d.svg";